<template>
  <div>
    <div v-if="isPreview" class='list-product'>
      <div class=''>
        <div :style="{backgroundImage:`url(${previewImage})`}" class="prj-thumb margin-bottom--s"></div>
        <router-link :to="'/blog/' + slug">
          <h2 class='txt-blog-title' v-on:click="scrollToTop">{{ title }}</h2>
        </router-link>
        <p class='txt-body' v-html="excerpt"></p>
        <ul class='tags'>
          <li>{{ date }}</li>
          <li v-for="tag in tags" v-bind:key="tag">{{ tag }}</li>
        </ul>
        <router-link :to="'/blog/' + slug" class='textlink'><span v-on:click="scrollToTop">View this post</span></router-link>
      </div>
    </div>
    
    <div v-if="!isPreview" class='r'>
      <div class='c-3'></div>
      <div class='c-6 section-page-title'>
        <div class='prj-info-wrapper'>
          <h2 class='txt-section-name'>{{ title }}</h2>
          <ul class='tags'>
            <li>{{ date }}</li>
            <li v-for="tag in tags" v-bind:key="tag">{{ tag }}</li>
          </ul>
        </div>
      </div>
      <div class='c-3'></div>
      <div class='c-3'></div>
      <p v-html="content" class='c-6'></p>
    </div>
  </div>
</template>

<script>
// Importing swiper for swiping images
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

export default {
  name: 'project',
  data() {
    return {
      
    }
  },
  props: {
    slug: {
      type: String
    },
    title: {
      type: String
    },
    date: {
      type: String
    },
    excerpt: {
      type: String
    },
    tags: {
      type: Array
    },
    previewImage: {
      type: String
    },
    fullImage: {
      type: String
    },
    content: {
			type: String
    },
    nextSlug: {
      type: String
    },
    nextTitle: {
      type: String
    },
    metaTitle: {
      type: String
    },
    metaDesc: {
      type: String
    },
    metaType: {
      type: String
    },
    metaUrl: {
      type: String
    },
    metaImage: {
      type: String
    },
    metaTwitter: {
      type: String
    }
  },
  computed: {
    // Returns true if project should display as preview
		isPreview: function() {
			if(this.previewImage) {
				return true
			}
			return false 
    }
  },
  head: {
    title: function () {
      if(!this.previewImage) {
        return {
          inner: this.metaTitle
        }
      } else if (this.previewImage) {
        return {
          inner: 'Blog'
        }
      }
    },
    meta: function () {
      if(!this.previewImage) {
        return [
          { name: 'description', content: this.metaDesc },
          { property: 'og:title', content: this.metaTitle },
          { property: 'og:description', content: this.metaDesc },
          { property: 'og:type', content: this.metaType },
          { property: 'og:url', content: this.metaUrl },
          { property: 'og:image', content: this.metaImage },
          { name: 'twitter:card', content: this.metaTwitter }
        ]
      }
    }
  },
  methods: {
    scrollToTop: function() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  },
  mounted: function() {
    if(this.content) {
      // Swiper - Add appropriate class names to the existing DOM
      var swiperContainer = document.getElementsByClassName('wp-block-gallery');
      var swiperWrapper = document.getElementsByClassName('blocks-gallery-grid');
      var swiperSlide = document.getElementsByClassName('blocks-gallery-item');
      for (var i = 0; i < swiperContainer.length; i++) {
          swiperContainer[i].classList.add('swiper-container');
      }
      for (var i = 0; i < swiperWrapper.length; i++) {
          swiperWrapper[i].classList.add('swiper-wrapper');
      }
      for (var i = 0; i < swiperSlide.length; i++) {
          swiperSlide[i].classList.add('swiper-slide');
      }

      // Create pagination in the existing DOM
      for (var i = 0; i < swiperContainer.length; i++) {
        // create a new div element
        var newDiv = document.createElement("div");
        swiperContainer[i].setAttribute("id", "swiperContainer");
        var parent = swiperContainer[i];
        var currentEl = parent.lastElementChild;
        parent.insertBefore(newDiv, currentEl.nextElementSibling);
        parent.lastElementChild.classList.add("swiper-pagination");
      }

      // Initialize the Swiper
      var mySwiper = new Swiper('.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        speed: 400,
        slidesPerView: 1.1,
        centeredSlides: true,
        spaceBetween: 8,
        updateOnWindowResize: true,
        watchOverflow: true,
        grabCursor: true,
        loop: true,
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        },
        // Navigation arrows
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  // Common
  .tags {
    margin-bottom: var(--space-xs);
    > li:not(:last-child)::after {
     content: ',';
    }
  }

  // Project preveiw list styles
  .list-product {
    margin-bottom: 30vh;
    @include media("<=tablet") {
      margin-bottom: var(--space-xxl);
    }
  }

  // Product page styles
  .prj-featured {
    padding-top: calc(56.25% + 48px);
    background-repeat: none;
    background-position: center center;
    background-size: cover;
    margin-left: -24px;
    margin-right: -24px;
    margin-bottom: var(--space-md);
    @include media("<=tablet") {
      padding-top: calc(100% + 48px);
    }
  }

</style>